<script setup lang="ts">
    
import type { Nullish } from "@ca/types/util";

import { computed } from "vue";

const props = defineProps<{
	label: string;
	value: Nullish<string>;
	subValue?: Nullish<string>;
	variant?: "default" | "lg";
	isLoading?: boolean;
	to?: string;
}>();

const valueSize = computed(() => {
	if (props.variant === "lg") {
		return "text-2xl/none";
	}
	return "text-xl/none";
});
    

</script>
      
<template>
  <UCard
    variant="subtle"
  >
    <template #header>
      <h4 class="font-cta text-brand-500 text-base/none">
        {{ label }}
      </h4>
    </template>
    <template #default>
      <USkeleton
        v-if="isLoading"
        class="w-4/5 mx-auto h-8"
      />
      <div v-else>
        <router-link
          v-if="to"
          :to="to"
        >
          <p
            :class="valueSize"
            class="text-center"
          >
            {{ value ?? "--" }}
          </p>
        </router-link>
        <p
          v-else
          :class="valueSize"
          class="text-center"
        >
          {{ value ?? "--" }}
        </p>
        <p
          v-if="subValue"
          class="text-gray-400 text-center mt-2 text-sm"
        >
          {{ subValue }}
        </p>
      </div>
    </template>
  </UCard>
</template>